<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('add_to_segment') }}
      v-spacer
      v-btn(icon @click="showDialog = false")
        v-icon mdi-close
    v-divider

    v-card-text.py-8
      segments-dropdown(:selectedSegment.sync="selectedSegment" @added="$emit('addNewSegment')")
    v-divider

    v-card-actions.py-4.px-6
      v-spacer
      v-btn.button-md.primary400--text(@click="showDialog = false" text) {{ $t('cancel') }}
      v-btn.button-md.white--text(:loading="isSaving" color="neutral700" depressed :disabled="!selectedSegment" @click="confirm") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SegmentsDropdown from '@/components/clinic/segments/SegmentsDropdown.vue'

export default {
  components: {
    SegmentsDropdown,
  },
  props: ['open', 'customers'],
  data: () => ({
    isSaving: false,
    selectedSegment: null,
    rules: {
      not_empty: [v => v.trim().length || 'This field is required'],
      not_empty_array: [v => !!(v && v.length) || 'This field is required']
    },
    firstSegment: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    confirm () {
      if (this.selectedSegment) {
        this.isSaving = true
        const selectedCustomers = this.customers.map(item => item.id)
        const prevCustomers = this.selectedSegment.customer || []
        const ids = [...new Set([...selectedCustomers, ...prevCustomers])]
        this.$axios.patch(`/connect/${this.company.slug}/groups/${this.selectedSegment.id}/`, { customer: ids })
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.customer_added_segment_successfully')])
            this.$emit('success', resp.data)
            this.showDialog = false
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    }
  }
}
</script>